Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CodePen", {
  enumerable: true,
  get: function get() {
    return _codepen.CodePen;
  }
});
var _codepen = require("./codepen");